// extracted by mini-css-extract-plugin
module.exports = {"partnerLogoWrapper":"bB41U","partnerLogo":"Ek1Ob","partnerDescription":"_1tZKY","partnerTitle":"KbgkX","partnerId":"HQsX8"};